var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAccountEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 42,
    fill: "url(#paint0_linear_96_1928)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6652 30.7155H25.0356V29.3703L54.6297 27.0028V29.3703H58.6652V25.3348C58.6652 22.3753 56.2681 20.2984 53.341 20.7154L26.3269 24.5734C23.3971 24.9931 21 27.7561 21 30.7155V57.6193C21 59.0463 21.5669 60.4149 22.576 61.424C23.5851 62.4331 24.9537 63 26.3807 63H58.6652C60.0923 63 61.4609 62.4331 62.47 61.424C63.4791 60.4149 64.046 59.0463 64.046 57.6193V36.0963C64.046 34.6692 63.4791 33.3006 62.47 32.2915C61.4609 31.2824 60.0923 30.7155 58.6652 30.7155ZM54.6297 49.5643C54.0996 49.5641 53.5746 49.4595 53.0849 49.2565C52.5952 49.0534 52.1503 48.7559 51.7756 48.3809C51.4008 48.006 51.1036 47.5608 50.9009 47.071C50.6982 46.5811 50.5939 46.0562 50.5941 45.526C50.5943 44.9959 50.6989 44.471 50.9019 43.9813C51.105 43.4916 51.4025 43.0466 51.7775 42.6719C52.1524 42.2972 52.5976 41.9999 53.0874 41.7972C53.5773 41.5945 54.1022 41.4903 54.6324 41.4905C55.703 41.4908 56.7297 41.9165 57.4865 42.6738C58.2433 43.4311 58.6683 44.4581 58.6679 45.5287C58.6676 46.5994 58.2419 47.626 57.4846 48.3828C56.7273 49.1397 55.7003 49.5646 54.6297 49.5643Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_96_1928",
    x1: 42,
    y1: 84,
    x2: 42,
    y2: 0.0000104464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7831F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB930"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountEmpty);
export default __webpack_public_path__ + "static/media/icon_account_empty.17ad6cfb17850087135bd6ba382bdf87.svg";
export { ForwardRef as ReactComponent };